import {
  Autocomplete,
  Button,
  TextField,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { GridCloseIcon } from '@mui/x-data-grid';
import Swal from 'sweetalert2';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import OpaqueLoading from '../../../components/opaqueLoading/opaqueLoading';

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  width: 100%;
  ${isMobile && `position: relative;`}
`;

const Container = styled.div`
  width: 100%;
`;

const errorDescription = {
  fontSize: '16px',
  fontWeight: '400',
  color: 'oklch(44.4% 0.177 26.899)',
};

const warningText = {
  fontSize: '18px',
  fontWeight: '500',
  color: 'oklch(44.4% 0.177 26.899)',
  marginTop: '20px',
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const AssignTargetAchievement = () => {
  const navigate = useNavigate();

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedEvent, setSelectedEvent] = useState();
  const [currentYear, setCurrentYear] = useState();
  const [events, setEvents] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [tableHeaders, setTableHeaders] = React.useState();
  const [paramsPayload, setParamsPayload] = React.useState([]);
  const [paramsPayloadFinal, setParamsPayloadFinal] = React.useState([]);
  const [isValid, setIsValid] = React.useState();
  const [errors, setErrors] = React.useState({});

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      const years = [];
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      years.push(currentYear);
      years.push(nextYear);
      setYears(years);
      setCurrentYear(currentYear);
      getActivityType();
    } else {
      window.location.reload();
    }
  }, []);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const getActivityType = async () => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getActivityType();
      setEvents(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleMonthChange = async (value) => {
    setSelectedMonth(value ?? '');
    setSelectedEvent('');
  };

  const handleYearChange = async (value) => {
    setSelectedYear(value ?? '');
    setSelectedMonth('');
    setSelectedEvent('');
  };

  const handleEventChange = async (value) => {
    setSelectedEvent(value?.value ?? '');
    setParamsPayloadFinal([]);
    setParamsPayload([]);
    setErrors({});
    setIsValid(null);
    handleFilterSubmit(selectedMonth, selectedYear, value?.value);
  };

  const handleFilterSubmit = async (month, year, eventType) => {
    try {
      const result = await getTableHeaders(month, year, eventType);

      if (result.hasError) {
        window.NotificationUtils.showError(result.message);
        throw new Error(`Update expense failed.`);
      }
    } catch (error) {}
  };

  const handleInputChange = (e, row, item) => {
    let { value } = e.target;

    value = value.replace(/^0+(?!$)/, '');
    if (value === '') value = '0';

    setParamsPayloadFinal((prev) => {
      const updated = [...prev];

      const existingIndex = updated.findIndex(
        (entry) =>
          entry.sfid === row.sfid &&
          entry.product__c === item.product__c &&
          entry.month__c === selectedMonth
      );

      const newEntry = {
        sfid: row.sfid,
        month__c: selectedMonth,
        target__c: value,
        year__c: new Date().getFullYear(),
        productname: item.key,
        product__c: item.product__c,
        eventType: selectedEvent,
        targetsfid: item?.sfid,
      };

      if (existingIndex !== -1) {
        updated[existingIndex] = newEntry;
      } else {
        updated.push(newEntry);
      }

      return updated;
    });

    setParamsPayload((prev) => {
      const updated = [...prev];

      const existingIndex = updated.findIndex(
        (entry) =>
          entry.sfid === row.sfid &&
          entry.product__c === item.product__c &&
          entry.month__c === selectedMonth
      );

      const newEntry = {
        sfid: row.sfid,
        month__c: selectedMonth,
        target__c: value,
        year__c: new Date().getFullYear(),
        productname: item.key,
        product__c: item.product__c,
        eventType: selectedEvent,
        targetsfid: item?.sfid,
      };

      if (existingIndex !== -1) {
        updated[existingIndex] = newEntry;
      } else {
        updated.push(newEntry);
      }

      const isValid = validateProductTargetLimits(updated, tableHeaders.limit);

      setIsValid(isValid);

      return updated;
    });
  };

  const handleInputChange2 = (e, row) => {
    let { value } = e.target;

    value = value.replace(/^0+(?!$)/, '');
    if (value === '') value = '0';

    setParamsPayloadFinal((prev) => {
      const updated = [...prev];

      const existingIndex = updated.findIndex(
        (entry) =>
          entry.sfid === row.sfid &&
          entry.name__c === row.name__c &&
          entry.month__c === selectedMonth
      );

      const newEntry = {
        name__c: row.name__c,
        sfid: row.sfid,
        target__c: value,
        targetsfid: row?.targetSfid,
        eventType: selectedEvent,
        month__c: selectedMonth,
        year__c: selectedYear,
      };

      if (existingIndex !== -1) {
        updated[existingIndex] = newEntry;
      } else {
        updated.push(newEntry);
      }

      return updated;
    });

    setParamsPayload((prev) => {
      const updated = [...prev];

      const existingIndex = updated.findIndex(
        (entry) =>
          entry.sfid === row.sfid &&
          entry.name__c === row.name__c &&
          entry.month__c === selectedMonth
      );

      const newEntry = {
        name__c: row.name__c,
        sfid: row.sfid,
        target__c: value,
        targetsfid: row?.targetSfid,
        eventType: selectedEvent,
        month__c: selectedMonth,
        year__c: selectedYear,
      };

      if (existingIndex !== -1) {
        updated[existingIndex] = newEntry;
      } else {
        updated.push(newEntry);
      }

      const isValid = validateProductTargetLimits(updated, tableHeaders.limit);

      setIsValid(isValid);

      return updated;
    });
  };

  const getTableHeaders = async (
    month = null,
    year = null,
    eventType = null
  ) => {
    try {
      if (!month || !year || !eventType) {
        setTableHeaders([]);
        setTotal(0);
        return;
      }

      if (
        (!month || !selectedMonth) &&
        (!year || !selectedYear) &&
        (!eventType || !selectedEvent)
      ) {
        window.NotificationUtils.showError(
          'Month, year and event type must be selected to get filtered targets.'
        );
      } else {
        setLoading(true);
        setTableHeaders([]);
        setTotal(0);
        const result = await window.Platform.database.getTableHeader({
          Year__c: year ? year : selectedYear,
          eventType: eventType ? eventType : selectedEvent,
          Month__c: month ? month : selectedMonth,
        });

        const condition = result?.data.headerData?.some((item) =>
          [
            'Van Campaign',
            'Retailer Meet',
            'Balloon Show',
            'Krishi Mela',
          ].includes(item.key)
        );

        const finalData = !condition
          ? result.data.employeeData.flatMap((it1) => {
              return it1.data
                ?.filter((it2) => it2.Value && it2.Value > 0)
                ?.map((it2) => ({
                  sfid: it1.sfid,
                  product__c: it2.product__c,
                  month__c: selectedMonth,
                  year__c: selectedYear,
                  eventType: eventType ? eventType : selectedEvent,
                  targetsfid: it2.sfid,
                  productname: it2.key,
                  target__c: it2.Value,
                }));
            })
          : result.data.employeeData?.map((it1) => {
              return {
                name__c: it1.name__c,
                sfid: it1.sfid,
                month__c: selectedMonth,
                target__c: it1.targetData,
                year__c: selectedYear,
                eventType: eventType ? eventType : selectedEvent,
                targetsfid: it1?.targetSfid,
              };
            });

        setTableHeaders(result.data);
        setParamsPayload(finalData);
        setTotal(result.data.employeeData?.length ?? 0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError(error?.message);
    }
  };

  const handleReset = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Exit',
      confirmButtonText: 'Continue',
    }).then((result) => {
      if (result.isConfirmed) {
        setParamsPayload((prev) =>
          prev.map((item) => ({
            ...item,
            target__c: '0',
          }))
        );
      }
    });
  };

  const validateProductTargetLimits = (paramsPayload, limitMap) => {
    const productTotals = {};
    const errorsObj = {};

    const typeOfEvent = paramsPayload[0].eventType;
    const bool = [
      'Van Campaign',
      'Retailer Meet',
      'Balloon Show',
      'Krishi Mela',
    ].includes(typeOfEvent);

    if (bool) {
      paramsPayload.forEach((entry) => {
        const value = Number(entry.target__c) || 0;
        productTotals['total'] = (productTotals['total'] || 0) + value;
      });

      const total = productTotals['total'];
      const limit = limitMap[typeOfEvent];

      if (limit !== undefined && total === limit) {
        setErrors((prev) => {
          delete prev[typeOfEvent];
          return prev;
        });
      } else {
        errorsObj[
          typeOfEvent
        ] = `The target limit for ${typeOfEvent} is ${limit}, but you have assigned ${total}. Please ensure the assigned target matches the specified limit.`;
      }
    } else {
      paramsPayload.forEach((entry) => {
        const name = entry.productname;
        const value = Number(entry.target__c) || 0;
        productTotals[name] = (productTotals[name] || 0) + value;
      });

      for (const product in productTotals) {
        const total = productTotals[product];
        const limit = limitMap[product];

        if (limit !== undefined && total === limit) {
          setErrors((prev) => {
            delete prev[product];
            return prev;
          });
        } else {
          errorsObj[product] = `${product},${limit},${total}`;
        }
      }
    }

    setErrors(errorsObj);

    return false;
  };

  const handleSubmit = async () => {
    if (paramsPayloadFinal.length === 0) {
      window.NotificationUtils.showError(
        'Please add some targets to continue.'
      );
      return;
    }

    const respBody = {
      paramData: paramsPayloadFinal,
    };

    if (Object.keys(errors)?.length > 0) {
      handleDialogOpen();
      return;
    }

    if (Object.keys(errors)?.length === 0) {
      setLoading(true);
      const result = await window.Platform.database.assignTargetByRMM(respBody);

      if (result.hasError) {
        window.NotificationUtils.showError(result?.message);
        return;
      }

      setTableHeaders([]);
      setTotal(0);
      setSelectedYear(null);
      setSelectedMonth('');
      setSelectedEvent(null);
      setParamsPayload([]);

      window.NotificationUtils.showSuccess(result?.message);
      setLoading(false);
      navigate('/assigned-target-achievement');
    } else {
      window.NotificationUtils.showError('Limit exceeded');
    }
  };

  const renderContent = () => {
    return (
      <Box
        style={{
          height: !tableHeaders?.employeeData?.length ? '380px' : '550px',
          overflow: 'auto',
        }}
      >
        {tableHeaders?.employeeData?.length > 0 && (
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: '10px',
              overflowX: 'auto',
              maxWidth: '100%',
              maxHeight: 500,
            }}
          >
            <Table sx={{ minWidth: 700 }} aria-label='spanning table'>
              <TableHead
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 3,
                }}
              >
                <TableRow sx={{ backgroundColor: '#77A600' }}>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 4,
                      backgroundColor: '#77A600',
                      color: '#FFF',
                      border: '1px solid #E6E6E6',
                    }}
                  >
                    Employee Name
                  </TableCell>
                  {tableHeaders?.headerData?.map((item) => {
                    return (
                      <TableCell
                        align='center'
                        sx={{
                          border: '1px solid #E6E6E6',
                          color: '#FFF',
                          backgroundColor: '#77A600',
                        }}
                        colSpan={item?.Value?.length ?? 0}
                      >
                        {item?.key}
                      </TableCell>
                    );
                  })}
                </TableRow>
                <TableRow sx={{ backgroundColor: '#77A600' }}>
                  {tableHeaders?.headerData?.map((headerItem, index) =>
                    headerItem?.Value?.map((valueItem, valueIndex) => (
                      <TableCell
                        key={`${index}-${valueIndex}`}
                        align='center'
                        sx={{
                          border: '1px solid #E6E6E6',
                          color: '#FFF',
                          backgroundColor: '#77A600',
                        }}
                      >
                        {valueItem}
                      </TableCell>
                    ))
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableHeaders?.employeeData &&
                  tableHeaders?.employeeData.map((row, newIndex) => {
                    return (
                      <TableRow
                        // hover
                        role='checkbox'
                        tabIndex={-1}
                        key={row.sfid}
                        sx={{
                          backgroundColor:
                            newIndex % 2 !== 0
                              ? 'rgb(246, 255, 222)'
                              : 'inherit',
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          key={row.name__c}
                          sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor:
                              newIndex % 2 !== 0
                                ? 'rgb(246, 255, 222)'
                                : '#FFF',
                            zIndex: 2,
                          }}
                        >
                          {row?.name__c}
                        </TableCell>

                        {!tableHeaders?.headerData?.some((item) =>
                          [
                            'Van Campaign',
                            'Retailer Meet',
                            'Balloon Show',
                            'Krishi Mela',
                          ].includes(item.key)
                        ) ? (
                          row?.data?.map((item) => {
                            return (
                              <TableCell key={item.key} align='center'>
                                <TextField
                                  variant='standard'
                                  sx={{
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    fontSize: '14px',
                                    padding: 0,
                                    '& .MuiInputBase-input': {
                                      padding: '4px 8px',
                                      textAlign: 'center',
                                    },
                                  }}
                                  name={item.key}
                                  value={
                                    paramsPayload.find(
                                      (entry) =>
                                        entry.sfid === row?.sfid &&
                                        entry.product__c === item.product__c &&
                                        entry.month__c === selectedMonth
                                    )?.target__c ||
                                    item.Value ||
                                    '0'
                                  }
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d+$/.test(value) || value === '') {
                                      handleInputChange(e, row, item);
                                    }
                                  }}
                                  InputProps={{
                                    disableUnderline: true,
                                    inputProps: {
                                      pattern: '[0-9]*',
                                      inputMode: 'numeric',
                                      min: 0,
                                    },
                                  }}
                                />
                              </TableCell>
                            );
                          })
                        ) : (
                          <TableCell align='center'>
                            <TextField
                              variant='standard'
                              sx={{
                                border: 'none',
                                backgroundColor: 'transparent',
                                fontSize: '14px',
                                padding: 0,
                                '& .MuiInputBase-input': {
                                  padding: '4px 8px',
                                  textAlign: 'center',
                                },
                              }}
                              name={row.name__c}
                              value={
                                paramsPayload.find(
                                  (entry) =>
                                    entry.sfid === row?.sfid &&
                                    entry.name__c === row?.name__c &&
                                    entry.month__c === selectedMonth
                                )?.target__c ||
                                row.target__c ||
                                '0'
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d+$/.test(value) || value === '') {
                                  handleInputChange2(e, row);
                                }
                              }}
                              InputProps={{
                                disableUnderline: true,
                                inputProps: {
                                  pattern: '[0-9]*',
                                  inputMode: 'numeric',
                                  min: 0,
                                },
                              }}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}

                <TableRow
                  sx={{
                    backgroundColor: '#77A600',
                  }}
                >
                  <TableCell
                    align='center'
                    sx={{
                      position: 'sticky',
                      left: 0,
                      bottom: 0,
                      backgroundColor: '#77A600',
                      color: '#FFF',
                      zIndex: 3,
                    }}
                  >
                    Total
                  </TableCell>

                  {!tableHeaders?.headerData?.some((item) =>
                    [
                      'Van Campaign',
                      'Retailer Meet',
                      'Balloon Show',
                      'Krishi Mela',
                    ].includes(item.key)
                  ) ? (
                    tableHeaders?.headerData?.map((headerItem, index) =>
                      headerItem?.Value?.map((valueItem, valueIndex) => {
                        const totalCount = paramsPayload
                          ?.filter((item) => item?.productname === valueItem)
                          ?.reduce(
                            (acc, item) => acc + Number(item.target__c || 0),
                            0
                          );

                        return (
                          <TableCell
                            key={`${index}-${valueIndex}`}
                            align='center'
                            sx={{
                              position: 'sticky',
                              bottom: 0,
                              left: 0,
                              backgroundColor: '#FFF',
                              zIndex: 2,
                            }}
                          >
                            {totalCount}
                          </TableCell>
                        );
                      })
                    )
                  ) : (
                    <TableCell
                      align='center'
                      sx={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        backgroundColor: '#FFF',
                        zIndex: 2,
                      }}
                    >
                      {paramsPayload?.reduce(
                        (acc, item) => acc + Number(item.target__c || 0),
                        0
                      )}
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='target-achievement' />
        <Box p={4}>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='space-between'
            flexWrap='wrap'
          >
            <Box display='flex' alignItems='center' gap='10px' mb={2}>
              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedYear || null}
                onChange={(event, newValue) => handleYearChange(newValue)}
                options={years}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Year'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    String(option)
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedMonth || null}
                onChange={(event, newValue) => handleMonthChange(newValue)}
                options={months}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                getOptionDisabled={(option) => {
                  const currentDate = new Date();
                  const currentMonthIndex = currentDate.getMonth(); // 0-based
                  const currentYear = currentDate.getFullYear();

                  // If selected year is current year, disable past months
                  if (parseInt(selectedYear) === currentYear) {
                    const monthIndex = months.findIndex(
                      (month) => month.toLowerCase() === option.toLowerCase()
                    );
                    return monthIndex < currentMonthIndex;
                  }
                  return false;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Month'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedEvent || null}
                onChange={(event, newValue) => handleEventChange(newValue)}
                options={events}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option?.eventName || ''
                }
                isOptionEqualToValue={(option, value) =>
                  option.eventName === value
                }
                fullWidth
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Event Type'
                    // onChange={(event) =>
                    //   debouncedSearchField(event, 'Expense Owner')
                    // }
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.eventName
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />
            </Box>
            <Box display='flex' alignItems='center' gap='10px' mb={2}>
              <Button variant='outlined' onClick={handleReset}>
                Cancel
              </Button>
              <Button
                variant='contained'
                onClick={handleSubmit}
                style={{
                  background:
                    'linear-gradient(90deg, #77A600 0%, #A8CF45 100%)',
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
          <StaffEditorPageContainer>
            <TableContainer>{renderContent()}</TableContainer>
          </StaffEditorPageContainer>
        </Box>

        <Dialog
          maxWidth='md'
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
              width: '100%',
              maxWidth: '800px',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            {Object.values(errors)[0]?.includes('The target limit') ? (
              Object.keys(errors).map((key) => (
                <p style={errorDescription} key={key}>
                  {errors[key]}
                </p>
              ))
            ) : (
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: '10px',
                  overflowX: 'auto',
                  maxWidth: '100%',
                  maxHeight: 500,
                }}
              >
                <Table sx={{ minWidth: 700 }} aria-label='spanning table'>
                  <TableHead sx={{ position: 'sticky', top: 0, zIndex: 3 }}>
                    <TableRow sx={{ backgroundColor: '#77A600' }}>
                      <TableCell
                        rowSpan={3}
                        sx={{
                          position: 'sticky',
                          left: 0,
                          zIndex: 5,
                          backgroundColor: '#77A600',
                          color: '#FFF',
                          border: '1px solid #E6E6E6',
                        }}
                      >
                        Product Name
                      </TableCell>

                      <TableCell
                        rowSpan={3}
                        sx={{
                          position: 'sticky',
                          left: 0,
                          zIndex: 4,
                          backgroundColor: '#77A600',
                          color: '#FFF',
                          border: '1px solid #E6E6E6',
                        }}
                      >
                        Target Assigned
                      </TableCell>

                      <TableCell
                        rowSpan={3}
                        sx={{
                          position: 'sticky',
                          left: 0,
                          zIndex: 4,
                          backgroundColor: '#77A600',
                          color: '#FFF',
                          border: '1px solid #E6E6E6',
                        }}
                      >
                        Limit
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {Object?.keys(errors)?.map((item, newIndex) => (
                      <TableRow
                        key={newIndex}
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        sx={{
                          backgroundColor:
                            newIndex % 2 !== 0
                              ? 'rgb(246, 255, 222)'
                              : 'inherit',
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor:
                              newIndex % 2 !== 0
                                ? 'rgb(246, 255, 222)'
                                : '#FFF',
                            zIndex: 5,
                          }}
                        >
                          {errors[item].split(',')[0]}
                        </TableCell>

                        <TableCell
                          sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor:
                              newIndex % 2 !== 0
                                ? 'rgb(246, 255, 222)'
                                : '#FFF',
                            zIndex: 2,
                            color: 'oklch(44.4% 0.177 26.899)',
                          }}
                        >
                          {errors[item].split(',')[2]}
                        </TableCell>

                        <TableCell
                          sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor:
                              newIndex % 2 !== 0
                                ? 'rgb(246, 255, 222)'
                                : '#FFF',
                            zIndex: 2,
                          }}
                        >
                          {errors[item].split(',')[1]}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {!Object.values(errors)[0]?.includes('The target limit') && (
              <p style={warningText}>
                The assigned targets do not match the respective product limits.
                Please ensure each target is equal to its corresponding product
                limit.
              </p>
            )}
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );
};

export default AssignTargetAchievement;
